<template>
  <div class="full-size">
    <buttons-group
      :items="filterItems"
      :indexStep="index"
      :indexDesabilitado="desabilitarTabelaDominio"
      :disabledAll="true"
      :width="260"
      @click="getIndex"
    />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

export default {
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      items: [
        'E-mail Áreas',
        //'Gerenciamento de Usuários',
        'Hierarquia',
        'Nova Unimed',
        'Parâmetros Gerais',
        'Tabelas de Domínios',
        'Tags Unimed',
        'Anexos',
        'Manuais'
      ],
      disabled: true,
      desabilitarTabelaDominio: [-1],
      role: jwtDecode(localStorage.getItem('tokenBearer')).role
    }
  },
  beforeMount() {
    if (!this.isAdminBrasil()) {
      this.desabilitarTabelaDominio = [9]
    }
  },
  methods: {
    getIndex(index) {
      this.$emit('changeAll', { tabName: this.getTabName(index), index })
    },
    getTabName(tab) {
      const tabsName = {
        0: () => 'E-mail Áreas',
        1: () => 'Hierarquia',
        2: () => 'Nova Unimed',
        3: () => 'Parâmetros Gerais',
        4: () => 'Tabelas de Domínios',
        5: () => 'Tags Unimed',
        6: () => 'Anexos',
        7: () => 'Manuais'
      }

      return (tabsName[tab] || tabsName['Tabelas de Domínios'])()
    },
    // getTabName(tab) {
    //   const tabsName = {
    //     0: () => 'E-mail Áreas',
    //     1: () => 'Gerenciamento de Usuários',
    //     2: () => 'Hierarquia',
    //     3: () => 'Nova Unimed',
    //     4: () => 'Parâmetros Gerais',
    //     5: () => 'Tabelas de Domínios',
    //     6: () => 'Tags Unimed',
    //     7: () => 'Anexos',
    //     8: () => 'Manuais'
    //   }

    //   return (tabsName[tab] || tabsName['Tabelas de Domínios'])()
    // },
    isAdminBrasil() {
      return this.role === 'admin_brasil'
    }
  },
  computed: {
    filterItems() {
      return this.items.filter((item) => {
        if (this.isAdminBrasil() && item !== 'Gerenciamento de Usuários')
          return item
        else return item === 'Manuais'
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.full-size
  width: 105% !important
  height: 520px !important
  overflow: hidden auto
</style>
